import PropTypes from 'prop-types'
import React from 'react'

const Header = props => {
  return (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="content">
      <div className="inner">
        <h1 style={{ color: `white` }}>Chia En Chiang</h1>
        <p style={{fontWeight: 500}}>
          I'm a software engineer based in California,
          specializing in software system and architecture.
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <a href="/me" class="button">Learn More →</a>
        </li>
      </ul>
    </nav>
  </header>
)
}

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
